<template>
  <div class="d-flex">
    <div v-if="item.has_banking_transaction" class="status-circle-badge badge-blue" v-b-tooltip.hover :title="$gettext('Connected to a bank transaction')">
      <font-awesome-icon icon="fa-solid fa-building-columns" />
    </div>
    <div v-if="item.created_via === 'woocommerce'" class="status-circle-badge badge-image" v-b-tooltip.hover :title="$gettext('Created via Woocommerce')">
        <img src="/static/img/woocommerce2.png" />
    </div>
    <div v-if="item.credited_invoice" class="status-circle-badge badge-brown" v-b-tooltip.hover :title="$gettext('Credited')">
      <font-awesome-icon icon="fa-solid fa-rotate-left" />
    </div>
    <div v-if="item.currency !== 'EUR'" class="status-circle-badge badge-blue" v-b-tooltip.hover :title="$gettext('Foreign currency')">
      <font-awesome-icon icon="fa-solid fa-dollar-sign" />
    </div>
    <div v-if="item.display_status.error" class="status-circle-badge badge-danger" v-b-tooltip.hover :title="$gettext('Error sending the invoice')">
      <font-awesome-icon icon="fa-solid fa-triangle-exclamation" />
    </div>
    <div v-if="!item.display_status.error && item.display_status.detailed_status === 'sending'" class="status-circle-badge badge-spinner" v-b-tooltip.hover :title="$gettext('Sending')">
    </div>
    <div v-if="item.uploaded || item.correction" class="status-circle-badge badge-blue" v-b-tooltip.hover :title="$gettext('Uploaded')">
      <font-awesome-icon icon="fa-solid fa-cloud-arrow-up" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatusIcons',
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  computed: {

  },
}
</script>

<style lang="scss" scoped>

</style>